/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DropDiscordWidget } from './DropDiscordWidget';
import {
    DropDiscordWidgetFromJSON,
    DropDiscordWidgetFromJSONTyped,
    DropDiscordWidgetToJSON,
    DropDiscordWidgetToJSONTyped,
} from './DropDiscordWidget';

/**
 * 
 * @export
 * @interface DropDiscordWidgetResponse
 */
export interface DropDiscordWidgetResponse {
    /**
     * 
     * @type {DropDiscordWidget}
     * @memberof DropDiscordWidgetResponse
     */
    widget?: DropDiscordWidget;
    /**
     * 
     * @type {number}
     * @memberof DropDiscordWidgetResponse
     */
    computedAt: number;
}

/**
 * Check if a given object implements the DropDiscordWidgetResponse interface.
 */
export function instanceOfDropDiscordWidgetResponse(value: object): value is DropDiscordWidgetResponse {
    if (!('computedAt' in value) || value['computedAt'] === undefined) return false;
    return true;
}

export function DropDiscordWidgetResponseFromJSON(json: any): DropDiscordWidgetResponse {
    return DropDiscordWidgetResponseFromJSONTyped(json, false);
}

export function DropDiscordWidgetResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): DropDiscordWidgetResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'widget': json['widget'] == null ? undefined : DropDiscordWidgetFromJSON(json['widget']),
        'computedAt': json['computedAt'],
    };
}

export function DropDiscordWidgetResponseToJSON(json: any): DropDiscordWidgetResponse {
    return DropDiscordWidgetResponseToJSONTyped(json, false);
}

export function DropDiscordWidgetResponseToJSONTyped(value?: DropDiscordWidgetResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'widget': DropDiscordWidgetToJSON(value['widget']),
        'computedAt': value['computedAt'],
    };
}

